/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Portuguese (Brazil)
export default {
  'confluence-analytics-chart.default-loading-text': 'Atualizando dados de análise...',
  'confluence-analytics-chart.tooltip.no-views-data': 'Sem dados',
  'confluence-analytics-chart.tooltip.views-overall':
    '{count, plural, one {1 visualização} other {{count} visualizações}}',
  'confluence-analytics-chart.tooltip.views-today-so-far':
    '{count, plural, one {1 visualização até agora} other {{count} visualizações até agora}}',
  'confuence-analytics-chart.accessible-table.caption': 'Visualizações de página',
  'confuence-analytics-chart.accessible-table.header.date': 'Data',
  'confuence-analytics-chart.accessible-table.header.view-count': 'Visualizações',
  'confuence-analytics-chart.accessible-table.no-view-count-data': 'Sem visualizações',
};
